import React, { Component } from "react";
import { Login } from "./Login";
import { Logout } from "./Logout";
import {
  LoginActions,
  LogoutActions,
} from "./ApiAuthorizationConstants";
import { Route, Routes } from "react-router-dom";

export default class ApiAuthorizationRoutes extends Component {
  render() {
    return (
      <Routes>
        <Route
          path={LoginActions.Login}
          element={<Login action={LoginActions.Login}></Login>}
        />
        <Route
          path={LoginActions.LoginFailed}
          element={<Login action={LoginActions.LoginFailed}></Login>}
        />
        <Route
          path={LoginActions.LoginCallback}
          element={<Login action={LoginActions.LoginCallback}></Login>}
        />
        <Route
          path={LoginActions.Profile}
          element={<Login action={LoginActions.Profile}></Login>}
        />
        <Route
          path={LoginActions.Register}
          element={<Login action={LoginActions.Register}></Login>}
        />
        <Route
          path={LogoutActions.Logout}
          element={<Logout action={LogoutActions.Logout}></Logout>}
        />
        <Route
          path={LogoutActions.LogoutCallback}
          element={<Logout action={LogoutActions.LogoutCallback}></Logout>}
        />
        <Route
          path={LogoutActions.LoggedOut}
          element={<Logout action={LogoutActions.LoggedOut}></Logout>}
        />
      </Routes>
    );
  }
}
